import React from 'react';
import { getIntlString } from '@goparrot-dashboard/i18n';
import { MarketEmptyState } from '@market/react';

export const PageNotFound = () => (
  <section className="tw-flex tw-justify-center tw-p-4 tw-pt-20">
    <MarketEmptyState className="tw-max-w-xl tw-w-full">
      <h2 slot="primary-text" className="tw-mb-0">
        {getIntlString('page.not-found.title')}
      </h2>
      <p slot="secondary-text">{getIntlString('page.not-found.body')}</p>
    </MarketEmptyState>
  </section>
);
